import { useMediaQuery } from '@mui/material';
/**
 * Used by `GlobalApp` to control menu and pinned bar visibility.
 * @returns {boolean} `true` if users pointing device supports hover.
 */
export function useHoverSupported() {
    return useMediaQuery('screen and (hover: hover) and (pointer: fine)', { noSsr: true });
}
